//
//
//
//
//
//

export default {
  props: {
    text: {
      type: String,
      default: '展开全部',
    },
  },
  data() {
    return {
      all: false,
    }
  },
  methods: {
    onShowAll() {
      this.all = !this.all
      this.$emit('onCollapse', this.all)
    },
  },
}
